import React, { useContext, useEffect, useState } from 'react';

import { hasPermission, hasPermissionPerfil } from '@app/helpers/permissions';
import { GridView, CompositeView, SimpleView } from '@digital/ui';

import AbaDadosGerais from '../dadosGerais/AbaDadosGerais';
import AbaHistorico from '../historico/AbaHistorico';
import AbaGovernanca from '../governanca/AbaGovernanca';
import AbaAnalise from '../analise/AbaAnalise';
import AbaSumario from '../sumario/AbaSumario';
import EditQuestionarioContratacao from '../QuestionarioContratacao/EditQuestionarioContratacao';
import QuestionarioContextProvider from '../../../../hooks/useQuestionario';
import { getLoggedId } from '@app/helpers';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';

import { AbaQuestionarioMinuta } from '@app/views/PreSuprimentos/Demandas/QuestionarioDaMinuta/AbaQuestionarioMinuta';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';
import { EStepQuestionarioDemanda } from '@app/enums/EStepQuestionarioDemanda';
import { EGuidPerfilAcesso } from '@app/enums/EGuidPerfilAcesso';
import AbaHistoricoFaturamentoDireto from '../historico/AbaHistoricoFaturamentoDireto';

const Abas = () => {
  const {
    id,
    demandaData,
    isGPC
  } = useContext(QuestionarioContextProvider);

  const [loggedId] = useState(getLoggedId());

  return (
    <SimpleView>
      <CompositeView>
        {id === null
          || (demandaData && (demandaData.demandanteId === loggedId || demandaData.requisitanteId === loggedId))
          || hasPermission(['PRE_SUPRIMENTOS_DEMANDA_VISUALIZAR_ABA_QUESTIONARIO'])
          ? (
            <GridView icon="ui-in_progress" title="Demanda" id="demanda" noform>
              <EditQuestionarioContratacao />
            </GridView>
          ) : (
            () => { }
          )}

        {demandaData ? (
          <GridView icon="commons-document" title="Sumário" id="sumario" noform>
            <AbaSumario />
          </GridView>
        ) : (
          () => { }
        )}

        {demandaData && hasPermission(['PRE_SUPRIMENTOS_DEMANDA_VISUALIZAR_ABA_DADOS_GERAIS']) ? (
          <GridView icon="business-new_company" title="DADOS GERAIS" id="dadosGerais" noform>
            <AbaDadosGerais />
          </GridView>
        ) : (
          () => { }
        )}

        {demandaData
          && demandaData.tipo !== ETipoDemanda.AcordodeFornecimento
          && (![
            EStatusDemanda.AguardandoPreenchimentoDemandante,
          ].includes(demandaData.statusCodigo || 0)
          || [
            EStepQuestionarioDemanda.ControladoriaOuControleFinanceiro,
          ].includes(demandaData.step || 0))
          && hasPermission(['PRE_SUPRIMENTOS_DEMANDA_VISUALIZAR_ABA_ANALISE']) ? (
          <GridView icon="business-documents" title="ANÁLISE" id="analise" noform>
            <AbaAnalise />
          </GridView>
        ) : (
          () => { }
        )}

        {(demandaData
          && (
            hasPermission(['PRE_SUPRIMENTOS_DEMANDA_VISUALIZAR_ABA_QUESTIONARIO_DA_MINUTA'])
            && [
              EStatusDemanda.AguardandoQuestionarioMinuta,
              EStatusDemanda.AguardandoConfirmacaoQuestionarioMinuta,
              EStatusDemanda.AguardandoGeracaoMinuta,
            ].includes(demandaData.statusCodigo || 0)
          ))
          && !isGPC
          && hasPermissionPerfil([
            EGuidPerfilAcesso.Demandante,
            EGuidPerfilAcesso.PreContratacao,
          ]) ? (
          <GridView icon="commons-document" title="Questionário da Minuta" id="questionarioMinuta" noform>
            <AbaQuestionarioMinuta />
          </GridView>
        ) : (
          () => { }
        )}

        {demandaData &&
          demandaData.governancaAprovacaoId &&
          hasPermission(['PRE_SUPRIMENTOS_DEMANDA_VISUALIZAR_ABA_GOVERNANCA_APROVACAO']) ? (
          <GridView icon="commons-bookmark" title="gov. aprovação" id="govAprovacao" noform>
            <AbaGovernanca />
          </GridView>
        ) : (
          () => { }
        )}

        {demandaData && id !== null ? (
          <GridView icon="calendar-time_search" noform id="historico" title="histórico">
            {demandaData.tipo == ETipoDemanda.FaturamentoDireto || demandaData.tipo == ETipoDemanda.AditivoFaturamentoDireto ? <AbaHistoricoFaturamentoDireto /> : <AbaHistorico />}
          </GridView>
        ) : (
          () => { }
        )}
      </CompositeView>
    </SimpleView>
  );
};
export default Abas;
